import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flexAlignCenter, mb, p} from "@pg-design/helpers-css";
import {HeartIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {propertyOffer} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {gtmClickListViewModal} from "../../../tracking/google_tag_manager/gtm_favourites_list";
import {getFullKMLink} from "../../../utils/get_full_km_link";
import {IComparisonToolInfo} from "./FavouritesInfoModalComparisonToolInfo";

export const FavouritesInfoModalSubscribeInfo = (props: IComparisonToolInfo) => {
    const {countedFavourites} = props;

    const linkTarget = useResponsiveLinkTarget();

    const handleClick = () => {
        gtmClickListViewModal();
    };

    const kmFavoritesLink = getFullKMLink(kmAppLink.site.offers.favouritesWithParams);

    return (
        <>
            <div css={header}>
                <HeartIcon size="2.5" wrapperColor="#fff" wrapperSize="2.5" />
                <Text as="span" variant="body_copy_2" css={[p(0, 0, 0, 0.5)]}>
                    Zobacz ulubione oferty
                </Text>
            </div>

            <Text as="div" variant="info_txt_1" css={contentWrapper}>
                Posiadasz{" "}
                <b>
                    {countedFavourites} {propertyOffer.accusative(countedFavourites)}
                </b>{" "}
                na liście ulubionych. Skorzystaj z poniższego przycisku, aby je przejrzeć i porównać.
            </Text>

            <Button href={kmFavoritesLink} target={linkTarget} variant="filled_primary" size="small" css={buttonStyles} onClick={handleClick}>
                Zobacz oferty
            </Button>
        </>
    );
};

const header = css`
    ${mb(2)}
    ${flexAlignCenter}
`;

const contentWrapper = (theme: Theme) => css`
    ${mb(2)}
    position: relative;
    background-color: #fff;

    @media (max-width: ${theme.breakpoints.md}) and (max-height: ${theme.breakpoints.sm}) {
        max-height: 21rem;
    }
`;

const buttonStyles = css`
    width: 180px;
    max-width: 100%;
`;
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flexAlignCenter, mb, p} from "@pg-design/helpers-css";
import {HeartIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {propertyOffer} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {gtmClickListViewModal} from "../../../tracking/google_tag_manager/gtm_favourites_list";
import {getFullKMLink} from "../../../utils/get_full_km_link";
import {IComparisonToolInfo} from "./FavouritesInfoModalComparisonToolInfo";

export const FavouritesInfoModalSubscribeInfo = (props: IComparisonToolInfo) => {
    const {countedFavourites} = props;

    const linkTarget = useResponsiveLinkTarget();

    const handleClick = () => {
        gtmClickListViewModal();
    };

    const kmFavoritesLink = getFullKMLink(kmAppLink.site.offers.favouritesWithParams);

    return (
        <>
            <div css={header}>
                <HeartIcon size="2.5" wrapperColor="#fff" wrapperSize="2.5" />
                <Text as="span" variant="body_copy_2" css={[p(0, 0, 0, 0.5)]}>
                    Zobacz ulubione oferty
                </Text>
            </div>

            <Text as="div" variant="info_txt_1" css={contentWrapper}>
                Posiadasz{" "}
                <b>
                    {countedFavourites} {propertyOffer.accusative(countedFavourites)}
                </b>{" "}
                na liście ulubionych. Skorzystaj z poniższego przycisku, aby je przejrzeć i porównać.
            </Text>

            <Button href={kmFavoritesLink} target={linkTarget} variant="filled_primary" size="small" css={buttonStyles} onClick={handleClick}>
                Zobacz oferty
            </Button>
        </>
    );
};

const header = css`
    ${mb(2)}
    ${flexAlignCenter}
`;

const contentWrapper = (theme: Theme) => css`
    ${mb(2)}
    position: relative;
    background-color: #fff;

    @media (max-width: ${theme.breakpoints.md}) and (max-height: ${theme.breakpoints.sm}) {
        max-height: 21rem;
    }
`;

const buttonStyles = css`
    width: 180px;
    max-width: 100%;
`;
